module.exports = {
      id: "usp-2-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.e66ad95c.svg#usp-2-usage",
      toString: function () {
        return this.url;
      }
    }